export const SEALED_INCIDENT_BANNER_MESSAGE =
  "SEALED - KNOWINGLY ACCESSING OR DISCLOSING THIS RECORD WITHOUT AUTHORIZATION IS A CIVIL VIOLATION SUBJECT TO A PENALTY OF NOT MORE THAN $1,000.00.";

const hasSealedSuspectVictimAffiliation = incident => {
  return incident?.incidentDetail?.incidentOffenses?.some(offense =>
    offense?.suspectVictimAffiliations?.some(affiliation => affiliation?.sealed)
  );
};

const hasSealedArrest = incident => {
  return incident?.incidentArrests?.some(
    arrest =>
      arrest?.sealed || arrest?.arrestCharges?.some(charge => charge?.sealed)
  );
};

export const hasSealedIncidentRecord = incident => {
  return Boolean(
    incident?.sealed ||
      incident?.personIncidentSpecifics?.some(pis => pis?.sealed) ||
      hasSealedArrest(incident) ||
      hasSealedSuspectVictimAffiliation(incident)
  );
};
